import { useState, useEffect, useRef } from 'react';
import logo from '../../Assets/Navbar/quickcare-logo.svg';
import userIcon from '../../Assets/Navbar/user-icon.svg';
import '../Styles/Navbar.css';

const Navbar = () => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false); // State for mobile menu
    const [isOpen, setIsOpen] = useState(false); // State for live chat
    const [isLoginDropdownOpen, setIsLoginDropdownOpen] = useState(false);
    const [isClinicDropdownOpen, setIsClinicDropdownOpen] = useState(false);
    const navBgRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            if (navBgRef.current) {
                if (window.scrollY > 0) {
                    navBgRef.current.classList.add('scrolled');
                } else {
                    navBgRef.current.classList.remove('scrolled');
                }
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const toggleLoginDropdown = (e) => {
        e.stopPropagation();
        setIsLoginDropdownOpen(!isLoginDropdownOpen);
    };

    const toggleClinicDropdown = (e) => {
        e.stopPropagation();
        setIsClinicDropdownOpen(!isClinicDropdownOpen);
    };

    const toggleMenu = (e) => {
        e.stopPropagation(); // Prevent event from bubbling up
        setIsMenuOpen(!isMenuOpen); // Toggle mobile menu
    };

    return (
        <div className="" onClick={() => { setIsMenuOpen(false); setIsOpen(false); setIsLoginDropdownOpen(false); setIsClinicDropdownOpen(false); }}>
            <header className="nav-bg" ref={navBgRef}>
                <nav className="navbar">
                    <div className="left">
                        <img src={logo} alt="QuickCare Logo" className="logo-img" style={{ cursor: 'pointer' }} onClick={() => window.location.href = '/'} />
                        <div className="nav-links">
                            <ul>
                                {/* <li className="home-dropdown">
                                    <a
                                        href="# "
                                        className="home-toggle-dropdown"
                                        onClick={toggleDropdown}
                                    > For Providers <i className='bx bx-chevron-down'></i></a>
                                    {isDropdownOpen && (
                                        <ul className="home-dropdown-menu">
                                            <li><a href="/products">Sexual Health</a></li>
                                            <li><a href="/products">Cosmetics</a></li>
                                            <li><a href="/products">IV Therapy</a></li>
                                        </ul>
                                    )}
                                </li> */}
                            </ul>
                        </div>
                    </div>
                    <div className="right">
                        <a href="https://shopify.getquickcare.com/products/founder-sprint-limited" className="nav-item signup-link" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', padding: '8px 16px', backgroundColor: '#4CAF50', color: 'white', borderRadius: '4px' }}>
                            Sign Up
                        </a>
                    </div>
                    {!isMenuOpen ? (
                        <button className="menu-button" onClick={toggleMenu}>☰</button>
                    ) : (
                        <button className="close-button" onClick={toggleMenu}>✖</button>
                    )}
                </nav>
            </header>
            {isMenuOpen && (
                <div className="mobile-menu" onClick={(e) => e.stopPropagation()}>
                    <ul>
                        <li><a href="https://shopify.getquickcare.com/products/founder-sprint-limited" target="_blank" rel="noopener noreferrer">Sign Up</a></li>
                    </ul>
                </div>
            )}
        </div>
    )
};

export default Navbar;